import React, { useState } from 'react';

const Contact = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch("https://formspree.io/f/moqgznod", {
        method: "POST",
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setShowSuccess(true);
        form.reset();
        setTimeout(() => setShowSuccess(false), 5000);
      } else {
        alert("Oops! There was a problem submitting your form");
      }
    } catch (error) {
      alert("Oops! Connection error.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 md:py-32 bg-white relative">
      {/* SUCCESS POPUP MESSAGE - Enhanced centering for mobile */}
      {showSuccess && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4 md:px-6">
          <div className="absolute inset-0 bg-[#0A1D37]/90 backdrop-blur-sm"></div>
          <div className="relative bg-white p-8 md:p-12 max-w-md w-full text-center shadow-2xl rounded-sm">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-[#D62828] text-white rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="fas fa-check text-2xl md:text-3xl"></i>
            </div>
            <h3 className="text-xl md:text-2xl font-black text-[#0A1D37] uppercase tracking-tighter">Inquiry Received!</h3>
            <p className="text-slate-500 mt-4 text-sm md:text-base leading-relaxed">
              Thank you for choosing <span className="text-[#D62828] font-bold">Ehsan Traders</span>. 
              Our team will review your project and contact you shortly.
            </p>
            <button 
              onClick={() => setShowSuccess(false)}
              className="mt-8 text-[10px] font-black uppercase tracking-widest text-[#0A1D37] border-b-2 border-[#D62828] pb-1 hover:text-[#D62828] transition-colors"
            >
              Close Message
            </button>
          </div>
        </div>
      )}

      <div className="container mx-auto px-6 md:px-12">
        {/* Header Section */}
        <div className="mb-12 md:mb-16 text-center lg:text-left">
          <span className="text-[#D62828] font-bold uppercase tracking-[0.4em] text-[10px] md:text-xs">Get In Touch</span>
          <h2 className="text-4xl md:text-6xl font-black text-[#0A1D37] mt-3 uppercase tracking-tighter leading-none">
            Let's Build <span className="text-transparent" style={{ WebkitTextStroke: '1px #0A1D37' }}>Together</span>
          </h2>
          <div className="h-1.5 w-20 bg-[#D62828] mt-6 mx-auto lg:mx-0"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          {/* Left Side: Contact Information Cards - Stacked on Mobile */}
          <div className="w-full lg:w-1/3 space-y-4 md:space-y-6">
            <div className="bg-[#F8FAFC] p-6 md:p-8 border-l-4 border-[#0A1D37] group hover:border-[#D62828] transition-all duration-300">
              <i className="fas fa-map-marker-alt text-[#D62828] text-lg mb-3"></i>
              <h4 className="text-[#0A1D37] font-black uppercase tracking-widest text-xs">Headquarters</h4>
              <p className="text-slate-500 mt-2 text-sm">Peshawar, PK</p>
            </div>

            <div className="bg-[#F8FAFC] p-6 md:p-8 border-l-4 border-[#0A1D37] group hover:border-[#D62828] transition-all duration-300">
              <i className="fas fa-phone-alt text-[#D62828] text-lg mb-3"></i>
              <h4 className="text-[#0A1D37] font-black uppercase tracking-widest text-xs">Direct Line</h4>
              <p className="text-slate-500 mt-2 text-sm">+92 312 8337788</p>
            </div>

            <div className="bg-[#F8FAFC] p-6 md:p-8 border-l-4 border-[#0A1D37] group hover:border-[#D62828] transition-all duration-300">
              <i className="fas fa-envelope text-[#D62828] text-lg mb-3"></i>
              <h4 className="text-[#0A1D37] font-black uppercase tracking-widest text-xs">Email Support</h4>
              <p className="text-slate-500 mt-2 text-sm break-all">NaumanDurani@gmail.com</p>
            </div>

            {/* Social Connect - Centered on Mobile */}
            <div className="pt-4 flex justify-center lg:justify-start space-x-4">
              {['facebook-f', 'twitter', 'linkedin-in', 'github'].map((icon, idx) => (
                <a key={idx} href="#" className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[#0A1D37] text-white hover:bg-[#D62828] transition-all duration-300 rounded-sm">
                  <i className={`fab fa-${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Right Side: Modern Minimalist Form */}
          <div className="w-full lg:w-2/3">
            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              <div className="flex flex-col">
                <label className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-2 ml-1">Full Name</label>
                <input 
                  required
                  name="name"
                  type="text" 
                  placeholder="E.g. John Doe" 
                  className="bg-[#F8FAFC] border-b-2 border-slate-200 py-4 px-4 outline-none focus:border-[#D62828] transition-all text-[#0A1D37] font-medium text-base rounded-none"
                />
              </div>

              <div className="flex flex-col">
                <label className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-2 ml-1">Email Address</label>
                <input 
                  required
                  name="email"
                  type="email" 
                  placeholder="john@example.com" 
                  className="bg-[#F8FAFC] border-b-2 border-slate-200 py-4 px-4 outline-none focus:border-[#D62828] transition-all text-[#0A1D37] font-medium text-base rounded-none"
                />
              </div>

              <div className="flex flex-col md:col-span-2">
                <label className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-2 ml-1">Project Subject</label>
                <input 
                  name="subject"
                  type="text" 
                  placeholder="What are you looking to build?" 
                  className="bg-[#F8FAFC] border-b-2 border-slate-200 py-4 px-4 outline-none focus:border-[#D62828] transition-all text-[#0A1D37] font-medium text-base rounded-none"
                />
              </div>

              <div className="flex flex-col md:col-span-2">
                <label className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-2 ml-1">Message</label>
                <textarea 
                  required
                  name="message"
                  rows="4" 
                  placeholder="Tell us about your goals..." 
                  className="bg-[#F8FAFC] border-b-2 border-slate-200 py-4 px-4 outline-none focus:border-[#D62828] transition-all text-[#0A1D37] font-medium text-base resize-none rounded-none"
                ></textarea>
              </div>

              <div className="md:col-span-2 pt-2">
                <button 
                  disabled={isSubmitting}
                  type="submit"
                  className="group flex items-center justify-center md:justify-between bg-[#0A1D37] text-white px-10 py-5 font-bold uppercase tracking-[0.2em] text-[10px] md:text-xs hover:bg-[#D62828] transition-all duration-500 w-full md:w-auto shadow-xl disabled:bg-slate-400"
                >
                  <span>{isSubmitting ? 'Sending...' : 'Send Inquiry'}</span>
                  <i className={`fas ${isSubmitting ? 'fa-spinner fa-spin' : 'fa-paper-plane'} ml-4 group-hover:translate-x-2 transition-transform`}></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;